import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import {Text, View} from 'react-native';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import Project from "../../../../../Common/DTO/Project";
import { styles } from "./FinanceSummaryViewStyle";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";

interface FinanceSummaryViewProps {
    project: Project;
    financeSummaryProperties: any[];
}

export const FinanceSummaryView = ({financeSummaryProperties, project}: FinanceSummaryViewProps) => {
    const {width, isMobile} = useWindowSizeContext();

    const fontSize = isMobile ? 8 : 12;
    const boxTitleFontSize = fontSize*1.33;
    const boxSubTitleFontSize = fontSize*2;
    const boxPaddingVertical = fontSize * 1.5;

    const financedObject = Helpers.getPropertyValue("FINANCED_OBJECT", project.projectPropertyValues);

    const titleStyle = {
        fontSize: fontSize*3
    };

    const subTitleStyle = {
        fontSize: fontSize*2.33
    };

    const yellowBoxStyle = {
        paddingVertical: boxPaddingVertical,
        marginTop: isMobile ? 12 : 0,
        marginRight: isMobile ? 0 : 18,
        width: isMobile ? width*0.55 : width * 0.178,
    };

    return (
      <View style={styles.page}>
        <TranslationView style={[styles.title, titleStyle]}>financeSummary.title</TranslationView>
          {financedObject !== undefined && (
              <>
                  <View style={{marginBottom: 32}}/>
                  <TranslationView style={[styles.subTitle, subTitleStyle]}>financeSummary.subTitle</TranslationView>
                  <View style={{marginBottom: 24}}/>
                  <Text style={[styles.boxSubTitle, {fontSize: boxTitleFontSize, fontWeight: 'normal'}]}>{financedObject}</Text>
              </>
          )}
          <View style={{marginBottom: 24}}/>
            <View style={ isMobile ? styles.colBoxes : styles.rowBoxes}>
                {financeSummaryProperties.map((property: any, index: number) => {
                  return (
                    <View key={index} style={[styles.yellowBox, yellowBoxStyle]}>
                      <Text style={[styles.boxTitle, {fontSize: boxTitleFontSize, flexWrap: 'wrap'}]}>{Helpers.getCorrectTranslation(property.projectPropertyKey.title)}</Text>
                      <Text style={[styles.boxSubTitle, {fontSize: boxSubTitleFontSize}]}>{property.value}</Text>
                  </View>
                  );
                })}
            </View>
       
      </View>
    );
  
}

export default FinanceSummaryView;